import BasicButton from "../../../components/Buttons/BasicButton";
import XsCont from "../../../components/containers/Xs";
import HeaderSignIn from "../../../components/headers/HeaderSignIn";
import BasicForm from "../../../components/textField/BasicForm";
import { getCognitoUser } from "../../../utils/cognitoUtils";
import { ValidationErrors } from "../../../utils/validationUtils";
import { Box, Typography } from "@mui/material";
import { CognitoUser } from "amazon-cognito-identity-js";
import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";

const PasswordForgotPage: FC = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ loginId: "" });
  const [errors, setErrors] = useState<ValidationErrors>({});

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleClickButton: () => void = (): void => {
    if (!form.loginId) {
      setErrors({ loginId: "ログインIDを入力してください。" });
      return;
    }
    const handleNavigation = () => {
      sessionStorage.setItem("loginId", form.loginId);
      navigate("/pw/reset");
    };
    try {
      const cognitoUser: CognitoUser = getCognitoUser(form.loginId);
      cognitoUser.forgotPassword({
        onSuccess: () => {
          handleNavigation();
        },
        onFailure: () => {
          handleNavigation();
        },
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
      navigate("/error");
    }
  };

  return (
    <>
      <HeaderSignIn />
      <XsCont>
        <Box mt={15} textAlign="center">
          <Typography variant="h5" gutterBottom>
            パスワードリセット
          </Typography>
        </Box>
        <Box
          component="form"
          mt={20}
          display="flex"
          flexDirection="column"
          gap={3}
        >
          <BasicForm
            label={"ログインID"}
            name={"loginId"}
            value={form.loginId}
            onChange={handleChange}
            error={!!errors.loginId}
            helperText={errors.loginId}
          />
          <BasicButton onClick={handleClickButton} mt={10}>
            リセットコード送信
          </BasicButton>
        </Box>
      </XsCont>
    </>
  );
};

export default PasswordForgotPage;
